// extracted by mini-css-extract-plugin
module.exports = {"counter":"ShopList_counter__3yHmF"};